(function ($) {

    $('.aggregation-toggle').on('click', function() {
        $('#aggregation_search').toggleClass('aggregation_search--visible');
    });

    $('.item-list__show-more, .item-list__show-less').on('click', function() {
        $(this.parentElement).children('.item-list__show-more, .item-list__show-less').toggle();
        $(this.parentElement).children('.item-list__hidden').toggle();
    });

    $('.aggregation-item__aggregation-name').on('click', function() {
        $(this).parent('li').toggleClass('search-aggregation__aggregation-list__item--visible');
    });

    $('.aggregation-item__aggregation-name').on('keypress', function(e) {
        if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space' || e.keyCode === 32 || e.keyCode === 13) {
            e.preventDefault();
            $(this).parent('li').toggleClass('search-aggregation__aggregation-list__item--visible');
        }
    });

    $(document).on('click', '.autocomplete-suggestions', function() {
        // Patch permettant l'utilisation de plusieurs autocomplete dans une même page, voir autocomplete.js également
        $('.js-submittedForm').submit();
    });

    // Traitement du formulaire de recheche par métier
    [].forEach.call(document.querySelectorAll('.metiers-autocomplete'), function(element) {
        element.addEventListener('addItem',function(event) {
            // alimenter le champ saisi
            var form = getClosest(element, 'form');
            if (form) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", "METIER");
                hiddenField.setAttribute("value", event.detail.value);
                form.append(hiddenField);
                form.submit();
            }
        },false);
    });



    var getClosest = function ( elem, selector ) {
        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function(s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                };
        }
        // Get closest match
        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if ( elem.matches( selector ) ) return elem;
        }
        return null;
    };
})(jQuery.noConflict());
